document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    const targetId = this.getAttribute("href").replace(/^\/#/, "#"); // /#brand → #brand
    const targetElement = document.querySelector(targetId);
    if (!targetElement) return;

    // ヘッダー高さの判定（モバイル/PC）
    const windowWidth = window.innerWidth;
    let headerHeight = 0;
    if (windowWidth <= 1023) {
      const mobileHeader = document.querySelector("#sticky-header");
      if (mobileHeader) headerHeight = mobileHeader.offsetHeight;
    } else {
      const pcHeader = document.querySelector("#pc-sticky-header-content");
      if (pcHeader) headerHeight = pcHeader.offsetHeight;
    }

    const targetPosition =
      targetElement.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: targetPosition - headerHeight,
      behavior: "smooth",
    });
  });
});
